import React from 'react';
import LegalLayout from './LegalLayout';

// TODO: Sobald eRecht24-API-Key vorhanden ist, ersetzt der Backend-Endpoint
// /api/legal/impressum diesen statischen Inhalt. Bis dahin manuell pflegen.
const Impressum = () => (
  <LegalLayout title="Impressum">
    <h2>Angaben gemäß § 5 TMG</h2>
    <p>
      Dwayne Advertising<br />
      Alexander Fischl<br />
      Beispielstraße 1<br />
      80331 München<br />
      Deutschland
    </p>

    <h2>Kontakt</h2>
    <p>
      Telefon: +49 89 1234567<br />
      E-Mail: hallo@dwayne-advertising.de
    </p>

    <h2>Umsatzsteuer-ID</h2>
    <p>
      Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
      DE000000000
    </p>

    <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
    <p>
      Alexander Fischl<br />
      Beispielstraße 1<br />
      80331 München
    </p>

    <h2>Streitschlichtung</h2>
    <p>
      Die Europäische Kommission stellt eine Plattform zur
      Online-Streitbeilegung (OS) bereit:{' '}
      <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-amber-600 underline">
        https://ec.europa.eu/consumers/odr/
      </a>
      .<br />
      Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>
    <p>
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
      vor einer Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <h2>Haftung für Inhalte</h2>
    <p>
      Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
      auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
      §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
      übermittelte oder gespeicherte fremde Informationen zu überwachen oder
      nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
    </p>

    <h2>Haftung für Links</h2>
    <p>
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren
      Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
      Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
      Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
      verantwortlich.
    </p>

    <h2>Urheberrecht</h2>
    <p>
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
      Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
      Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
      Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
      jeweiligen Autors bzw. Erstellers.
    </p>
  </LegalLayout>
);

export default Impressum;
